import Banner from "../components/servicesScreen/Banner";
import ServicesCards from "../components/servicesScreen/ServicesCards";

export default function ServicesPage() {
	return (
		<div>
			<Banner />
			<ServicesCards />
		</div>
	);
}
